import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils'

import styles from './ServiceCard.LoadingConfig.styles'

const loadingConfig = theme => [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.serviceIcon),
    main: [
      setLoadingConfigObject('line', 1, 172, styles.title),
      setLoadingConfigObject('line', 1, 68, styles.subtitle),
    ],
    style: styles.contentContainer,
  },
  {
    main: setLoadingConfigObject('square', 3, 437, styles.description),
    style: styles.descriptionContainer,
  },
]

export { loadingConfig, shimmerPlaceholderConfig }
